import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgInfoFilled = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      clipRule="evenodd"
      d="M23.611 12.668c0 6.064-4.916 10.98-10.981 10.98S1.648 18.733 1.648 12.669c0-6.065 4.917-10.982 10.982-10.982S23.61 6.603 23.61 12.668M11.53 7.934a1.1 1.1 0 0 1 1.1-1.1h.01a1.1 1.1 0 0 1 0 2.2h-.01a1.1 1.1 0 0 1-1.1-1.1m1.1 2.9a1.1 1.1 0 0 1 1.1 1.1v5.467a1.1 1.1 0 0 1-2.2 0v-5.467a1.1 1.1 0 0 1 1.1-1.1"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgInfoFilled);
export default Memo;
